import { takeLatest, call, put } from 'redux-saga/effects';
import fetchEntity from 'reducers/utils/fetchEntitySaga';
import createFetchTypes from 'reducers/utils/createFetchTypes';
import ApiClient from 'Services/ApiClient';
import { showAlertAction } from 'reducers/popUps/alertPopUpReducer';

import { showLoader, hideLoader } from 'reducers/popUps/loaderReducer';

const FETCH_DEVSTATS_REPORTS = createFetchTypes(
  'Marketplace/Reports/devStatsReport/FETCH_DEVSTATS_REPORTS'
);

const FETCH_URL = 'reports/getfilteredproductstatsreport';

function devStatsReport(state = { data: { pagedCollection: [] } }, action = {}) {
  switch (action.type) {
    case FETCH_DEVSTATS_REPORTS.REQUEST:
      return {
        ...state,
        loading: true
      };
    case FETCH_DEVSTATS_REPORTS.SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data
      };
    case FETCH_DEVSTATS_REPORTS.ERROR:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}

export const fetchDevStatsReport = {
  base: params => ({
    type: FETCH_DEVSTATS_REPORTS.BASE,
    params,
    url: FETCH_URL
  }),
  request: () => ({ type: FETCH_DEVSTATS_REPORTS.REQUEST }),
  success: data => ({ type: FETCH_DEVSTATS_REPORTS.SUCCESS, data }),
  failure: error => ({ type: FETCH_DEVSTATS_REPORTS.FAILURE, error })
};

export function* fetchDevStatsReportSaga({ url, params }) {
  yield put(showLoader());
  try {
    yield call(() => fetchEntity(fetchDevStatsReport, ApiClient.httpClient.post, url, params));
  } catch (error) {
    put(showAlertAction(error));
  }
  yield put(hideLoader());
}

export default devStatsReport;

export function* devStatsReportMiddleware() {
  yield takeLatest(FETCH_DEVSTATS_REPORTS.BASE, fetchDevStatsReportSaga);
}
